export default __webpack_public_path__ + "static/media/supported_by_logos.cb0357b2.png";